export enum IntentAutomationTypeEnum {
  BASIC = 'basic',
  ADVANCED = 'advanced',
}


